import { mapDateRangePresetToApiFormat } from '../../mappers/common/common';
import { GdStatRequirementsInput } from '../../typings/graphql-grid';
import { GridSourceParams } from '../../typings/grid';

export const mapGridParamsToStatRequirements = (params: GridSourceParams) => {
    const { statPeriod, goalIds } = params;

    let statRequirements: GdStatRequirementsInput = {
        goalIds
    };
    if (statPeriod) {
        const { statPreset, statFrom, statTo } = statPeriod;
        statRequirements = {
            ...statRequirements,
            preset: statPreset && mapDateRangePresetToApiFormat(statPreset),
            from: statFrom,
            to: statTo
        };
    }

    return statRequirements;
};
